import { io, Socket } from 'socket.io-client';
import { STORAGE_KEYS, getItem } from './storage';

let sharedSocket: Socket | null = null;

/**
 * Lazy-singleton socket — the app has one socket shared across hooks. Any
 * consumer should use `onSocketReady` rather than poke the raw instance so
 * listeners get re-bound across reconnects.
 */
export async function getSocket(): Promise<Socket> {
  if (sharedSocket?.connected) return sharedSocket;
  if (sharedSocket) {
    // A stale socket — disconnect and start fresh so auth is fresh.
    sharedSocket.disconnect();
    sharedSocket = null;
  }

  const token = await getItem(STORAGE_KEYS.ACCESS_TOKEN);

  // BASE_URL mirrors api-client: empty in dev (Vite proxy), absolute in native/prod.
  const BASE_URL = import.meta.env['VITE_API_URL'] ?? window.location.origin;

  sharedSocket = io(`${BASE_URL}/im`, {
    auth: { token: token ?? '' },
    transports: ['websocket'],
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    timeout: 8000,
  });

  return sharedSocket;
}

export function disconnectSocket(): void {
  sharedSocket?.disconnect();
  sharedSocket = null;
}
